/*
 *************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 *************************************************************************
 */

import {getParser} from 'bowser';

const isSupportedBrowser = (): boolean => {
	try {
		const browser = getParser(window.navigator.userAgent);

		// https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CCHome&title=Browser+Support+for+AH
		const isValidBrowser = browser.satisfies({
			chrome: '>=128',
			firefox: '>=128',
			safari: '>=16.5',
			edge: '>=129',
		});

		return isValidBrowser || false;
	} catch (err) {
		return false;
	}
};

const isCookieEnabled = (): boolean => {
	// Try to set a test cookie
	document.cookie = 'testCookie=1; path=/; SameSite=None; Secure';
	// Check if the cookie was set successfully
	const cookiesEnabled = document.cookie.indexOf('testCookie') !== -1;
	// Delete the test cookie
	document.cookie =
		'testCookie=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
	return cookiesEnabled;
};

const BrowserUtils = {
	isSupportedBrowser,
	isCookieEnabled,
};

export {BrowserUtils};
